<template>
  <component
    :is="inModal ? 'div' : WdsButtonGhost"
    class="recruiter-column-name"
    data-test="recruiter-column-name"
    @click="openDetails"
  >
    <WdsAvatarLabel :path="avatarPath" :initials="column.recruiter.name" truncated>
      <template #subText>
        <WdsStack direction-column>
          <WdsText primary :data-test="`recruiter-name-${rowIndex}`">
            {{ column.recruiter.name }}
          </WdsText>
          <WdsStack v-if="column.recruiter.market" direction-row align-center gap-xs>
            <WdsIcon
              :size="14"
              :name="`flag-${column.recruiter.market.code.toLowerCase()}` as WdsIconNameEnum"
            />
            <WdsText secondary sm>
              {{ column.recruiter.market.name }}
            </WdsText>
          </WdsStack>
        </WdsStack>
      </template>
    </WdsAvatarLabel>
  </component>
</template>

<script lang="ts" setup>
import { computed, inject } from 'vue'
import { WdsAvatarLabel, WdsButtonGhost, WdsIcon, WdsIconNameEnum, WdsStack, WdsText } from '@worksome/wds-components'
import { FragmentType, graphql, useFragment } from '@/gql'
import { getAvatarPath } from '@/utils/avatar'
import { TableInModal } from '@/components/GraphqlDataTable/injection'
import { useTablePanels } from '@/components/GraphqlDataTable/useTablePanels'

const { openRecruiterDetailPanel } = useTablePanels()

const CompanyRecruiterNameColumn = graphql(`
  fragment CompanyRecruiterNameColumn on CompanyRecruiter {
    id
    email
    recruiter {
      id
      name
      avatar
      market {
        code
        name
      }
    }
  }
`)

const props = defineProps<{
  row: FragmentType<typeof CompanyRecruiterNameColumn>
  rowIndex?: number
}>()
const column = computed(() => useFragment(CompanyRecruiterNameColumn, props.row))
const rowIndex = computed(() => props.rowIndex ?? 0)

const avatarPath = computed(() =>
  getAvatarPath(column.value.recruiter.avatar, column.value.recruiter.id),
)

// Inside a modal there is no panel to open, so the name is plain text rather than a dead button.
const inModal = inject(TableInModal, false)

const openDetails = () => {
  if (inModal) return
  openRecruiterDetailPanel({
    companyRecruiterId: column.value.id,
  })
}
</script>

<style lang="scss">
.recruiter-column-name {
  text-align: left;
}
</style>
